export default function HeroSection() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { value: '12,000+', label: '每日更新视频' },
    { value: '36', label: '内容分类频道' },
    { value: '7×24', label: '不间断更新' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
        <div
          className="absolute top-0 right-0 w-full md:w-[55%] h-full opacity-25 md:opacity-30"
          style={{
            backgroundImage: 'radial-gradient(circle at 70% 50%, oklch(0.52 0.20 20 / 0.12) 0%, transparent 60%), radial-gradient(circle at 30% 70%, oklch(0.62 0.16 65 / 0.08) 0%, transparent 50%)',
          }}
        ></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14 py-12 md:py-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              每日更新 · 独家爆料
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight tracking-tight">
              黑料视频
              <span className="block text-primary-500 mt-1">国产黑料视频在线平台</span>
            </h1>

            <p className="mt-4 text-base md:text-lg text-foreground-600 font-medium max-w-xl mx-auto lg:mx-0">
              一手黑料，实时追踪，热门黑料视频合集免费高清在线观看
            </p>

            <div className="mt-6 space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              <p>
                黑料视频平台每日汇聚全网最新国产黑料视频资源，覆盖娱乐圈独家爆料、网红内幕追踪、社会热点深挖等多元化内容。我们以最快的更新速度和最全的黑料视频合集，为每一位关注真相与娱乐资讯的用户提供高清流畅的在线观看体验。
              </p>
              <p>
                无论你是想第一时间获取热门黑料视频的追踪报道，还是寻找91黑料视频的完整国产专区入口，这里都能满足你。平台支持高清在线播放与免费下载，让你随时随地不错过任何一条重磅黑料。
              </p>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-6 justify-center lg:justify-start">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); handleScroll('#carousel'); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleScroll('#topics'); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg border-2 border-foreground-200 text-foreground-700 font-semibold text-base hover:border-foreground-400 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-300/20 via-accent-300/15 to-primary-200/20 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-200/60 aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20cinematic%20scene%20with%20warm%20crimson%20and%20dark%20amber%20lighting%2C%20featuring%20a%20stylish%20digital%20screen%20displaying%20abstract%20video%20content%20with%20motion%20blur%20effects%2C%20surrounded%20by%20floating%20lens%20flares%20and%20atmospheric%20particles%2C%20luxurious%20dark%20theater%20backdrop%20with%20velvet%20textures%2C%20editorial%20photography%20quality%20with%20rich%20contrast%20and%20dramatic%20shadows%2C%20professional%20cinematic%20composition%20with%20warm%20tone%20grading&width=900&height=675&seq=hero-main-visual&orientation=landscape"
                  alt="黑料视频平台主视觉 - 国产黑料视频在线观看平台"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}